<template>
<div>
	<div v-if="!openedApp">
		<p v-if="appsHere.length > 0">Click an app to open it</p>
		<p v-else>There are no apps installed here.</p>
		<div  class="list-group">
			<button type="button" v-for="app in appsHere" class="list-group-item list-group-item-action" v-on:click="openApp(app)">{{app.app_name}}</button>
		</div>
	</div>
	<div v-else>
		<div class="app-bar-controls d-flex justify-content-between align-items-center">
			<h3>{{openedApp.app_name}}</h3>

			<i class="icon-button fa fa-times" v-on:click="openedApp = false"></i>
		</div>
		<iframe id="appIframe" :src="iframeSrc" :style="{height:iframeHeight}"></iframe>
	</div>
</div>
</template>
<script type="text/javascript">
export default {
	name: "AddonAppTab",
	props: ["uiLocation"],
	data() {
		return {
			openedApp: false
		}
	},

	computed: {
		iframeSrc() {
			let url = this.openedApp.src

			if (url.indexOf("?") >= 0)
				return url+"&token="+this.$store.sessionToken
			else
				return url+"?token="+this.$store.sessionToken
		},
		appsHere() {
			if ("AddonApp" in this.$store.company && this.$store.company.AddonApp)
				return this.$store.company.AddonApp.filter(app => app.ui_location == this.uiLocation)

			return []
		},
		iframeHeight() {
			let iframe = document.getElementById("appIframe")

			if (iframe) {
				let height = iframe.contentWindow.document.body.scrollHeight
				if (height)
					return height+"px"
			}

			return "calc(100vh - 145px)";
		}
	},
	methods: {
		openApp(app) {
			this.openedApp = app
		}
	},
	created() {
		if (this.appsHere.length == 1)
			this.openedApp = this.appsHere[0]
	}
}
</script>

<style type="text/css" scoped>
	.app-bar-controls {
		margin-bottom: 10px;	
	}

	.app-bar-controls h3 {
		margin: 0;
	}

	iframe {
		width: calc(100% + 30px);
		margin: -15px;
		margin-top: 0;
		border: none;
	}
</style>